(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 97400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ MobileFilterButton; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "RO": function() { return /* binding */ MobileResetSection; },
/* harmony export */   "Ro": function() { return /* binding */ MobileFiltersTitle; },
/* harmony export */   "ck": function() { return /* binding */ Item; },
/* harmony export */   "d$": function() { return /* binding */ DesktopFilters; },
/* harmony export */   "e0": function() { return /* binding */ SearchNoResults; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "jL": function() { return /* binding */ Banner; },
/* harmony export */   "xA": function() { return /* binding */ Trainings; },
/* harmony export */   "yU": function() { return /* binding */ MobileCloseButton; },
/* harmony export */   "yu": function() { return /* binding */ BorderedPart; },
/* harmony export */   "z": function() { return /* binding */ MobileFilters; }
/* harmony export */ });
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96502);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50661);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40238);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);




var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__Wrapper",
  componentId: "sc-1agit50-0"
})(["display:flex;gap:", ";"], (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(20));
var Banner = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "Trainingselements__Banner",
  componentId: "sc-1agit50-1"
})(["width:", ";cursor:pointer;border-radius:", ";"], (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(320), (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(16));
var MobileFiltersTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Trainingselements__MobileFiltersTitle",
  componentId: "sc-1agit50-2"
})(["display:block;text-align:center;font-size:", ";font-weight:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
});
var MobileCloseButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__MobileCloseButton",
  componentId: "sc-1agit50-3"
})(["background:none;border:none;cursor:pointer;position:absolute;right:", ";top:", ";font-size:", ";"], (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(25), (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(10), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h6;
});
var MobileResetSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__MobileResetSection",
  componentId: "sc-1agit50-4"
})(["display:flex;justify-content:center;"]);
var MobileFilters = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__MobileFilters",
  componentId: "sc-1agit50-5"
})(["position:fixed;top:0;height:100vh;background:", ";left:0;padding:", ";z-index:9999;margin-top:", ";overflow-y:scroll;border-bottom:", " solid ", ";@media (min-width:", "px){display:none;}&.isOpen{transform:translateX(0);opacity:1;transition:transform 0.5s,opacity 1s;}&.isClose{transform:translateX(-350px);opacity:0;transition:transform 1s,opacity 1s;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(10), (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(80), (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(80), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.md */ .A.md);
var DesktopFilters = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__DesktopFilters",
  componentId: "sc-1agit50-6"
})(["display:none;@media (min-width:", "px){display:block;min-width:", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.md */ .A.md, (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(320));
var BorderedPart = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__BorderedPart",
  componentId: "sc-1agit50-7"
})(["border:1px solid ", ";border-radius:", ";margin-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.border;
}, (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(16), (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(40));
var Trainings = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__Trainings",
  componentId: "sc-1agit50-8"
})(["width:100%;padding:", " 0;@media (min-width:", "px){padding:0 0 0 ", ";}"], (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(10), _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.md */ .A.md, function (props) {
  return props.withoutFilters ? 0 : (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(25);
});
var MobileFilterButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "Trainingselements__MobileFilterButton",
  componentId: "sc-1agit50-9"
})(["background:none;border:none;cursor:pointer;padding:", " ", ";color:", ";@media (min-width:", "px){display:none;}"], (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(10), (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(4), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
}, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.md */ .A.md);
var Header = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__Header",
  componentId: "sc-1agit50-10"
})(["padding-bottom:", ";display:flex;flex-direction:column;align-items:flex-end;"], (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(10));
var Title = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
  displayName: "Trainingselements__Title",
  componentId: "sc-1agit50-11"
})(["font-size:", ";font-weight:", ";margin:", ";@media (min-width:", "px){margin:", ";}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.h4;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeights.textBold;
}, function (props) {
  return props.withMargin ? "".concat((0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(_constants__WEBPACK_IMPORTED_MODULE_0__/* .MOBILE_HEADER_HEIGHT */ .ZQ), " 0 ").concat((0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(20), " 0") : "0 0 ".concat((0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(20), " 0");
}, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.sm */ .A.sm, function (props) {
  return props.withMargin ? "".concat((0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(_constants__WEBPACK_IMPORTED_MODULE_0__/* .DESKTOP_HEADER_HEIGHT */ .cf), " 0 ").concat((0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(40), " 0") : "0 0 ".concat((0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(40), " 0");
});
var SearchNoResults = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__SearchNoResults",
  componentId: "sc-1agit50-12"
})(["font-size:", ";margin-top:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSizes.h6;
}, function (props) {
  return props.withoutMargin ? 0 : "".concat((0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hO)(20));
});
var Item = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Trainingselements__Item",
  componentId: "sc-1agit50-13"
})([""]);

/***/ }),

/***/ 22579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(11358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Articles/Articles.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleselements__Wrapper",
  componentId: "sc-1t1a63l-0"
})(["margin-top:", ";padding:", " 0;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var Articles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleselements__Articles",
  componentId: "sc-1t1a63l-1"
})(["display:flex;flex-direction:column;gap:", ";"], (0,polished_esm/* rem */.hO)(40));
var Article = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleselements__Article",
  componentId: "sc-1t1a63l-2"
})(["display:flex;gap:", ";flex-direction:column;@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm);
var ArticlesImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Articleselements__ArticlesImage",
  componentId: "sc-1t1a63l-3"
})(["width:", ";height:", ";border-radius:", ";object-fit:cover;"], (0,polished_esm/* rem */.hO)(180), (0,polished_esm/* rem */.hO)(180), (0,polished_esm/* rem */.hO)(12));
var ArticlesDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleselements__ArticlesDetail",
  componentId: "sc-1t1a63l-4"
})([""]);
var ArticlesDetailTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Articleselements__ArticlesDetailTitle",
  componentId: "sc-1t1a63l-5"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";color:", ";cursor:pointer;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h5;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(15), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var ArticlesDetailDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleselements__ArticlesDetailDate",
  componentId: "sc-1t1a63l-6"
})(["font-size:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.textBase;
});
var ArticlesDetailAnnotation = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Articleselements__ArticlesDetailAnnotation",
  componentId: "sc-1t1a63l-7"
})(["line-height:", ";"], (0,polished_esm/* rem */.hO)(24));
var EmptyMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Articleselements__EmptyMessage",
  componentId: "sc-1t1a63l-8"
})(["text-align:center;"]);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/interfaces/Filter.ts
var Filter = __webpack_require__(81057);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Articles/Articles.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var ArticlesTemplate = function ArticlesTemplate(_ref) {
  var articles = _ref.articles,
      count = _ref.count;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var showMore = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(pagination) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              router.replace({
                pathname: router.pathname,
                query: _objectSpread(_objectSpread({}, router.query), {}, (0,defineProperty/* default */.Z)({}, Filter/* FilterTypesInUrl.PAGE */.$R.PAGE, pagination.selected + 1))
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function showMore(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Articles, {
      children: (articles === null || articles === void 0 ? void 0 : articles.length) > 0 ? articles === null || articles === void 0 ? void 0 : articles.map(function (article, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Article, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ArticlesImage, {
            src: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/articles/").concat(article.photo)
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ArticlesDetail, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ArticlesDetailTitle, {
              onClick: function onClick() {
                return router.push("".concat(constants/* ROUTES.ARTICLE */.Z6.ARTICLE, "/").concat(article.slug));
              },
              children: article.title
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ArticlesDetailDate, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
                children: [t('blog.publishDate'), ":"]
              }), ' ', moment_default()(article.publicationDate).format('DD. MM. YYYY')]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArticlesDetailAnnotation, {
              children: article.annotation
            })]
          })]
        }, key);
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyMessage, {
        children: t('blog.emptyMessage')
      })
    }), (articles === null || articles === void 0 ? void 0 : articles.length) > 0 && (articles === null || articles === void 0 ? void 0 : articles.length) < count && /*#__PURE__*/(0,jsx_runtime.jsx)((react_paginate_default()), {
      breakLabel: "...",
      onPageChange: showMore,
      nextLabel: ">",
      previousLabel: "<",
      pageRangeDisplayed: constants/* TRAININGS_LIMIT_PER_PAGE */.jp,
      pageCount: count / constants/* TRAININGS_LIMIT_PER_PAGE */.jp,
      renderOnZeroPageCount: null,
      forcePage: Number(router.query[Filter/* FilterTypesInUrl.PAGE */.$R.PAGE]) - 1 || 0,
      containerClassName: "pagination",
      activeClassName: "active"
    })]
  });
};

/* harmony default export */ var Articles_Articles = (ArticlesTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(57130);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/services/article.service.ts
var article_service = __webpack_require__(93003);
// EXTERNAL MODULE: ./src/components/Trainings/Trainings.elements.tsx
var Trainings_elements = __webpack_require__(97400);
;// CONCATENATED MODULE: ./src/pages/blog.tsx


















var Blog = function Blog(props) {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.blog.title'),
      description: t('seo.blog.description'),
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      withPadding: true,
      mobileSidePadding: 20,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Trainings_elements/* Title */.Dx, {
        withMargin: !router.pathname.includes(constants/* ROUTES.MY_PV */.Z6.MY_PV),
        children: t('blog.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Articles_Articles, {
        articles: props === null || props === void 0 ? void 0 : props.articles,
        count: props.articlesCount
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

Blog.getInitialProps = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(ctx) {
    var query, _yield$articleApi$lis, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            query = ctx.query;
            _context.next = 4;
            return article_service/* articleApi.list */.$.list(constants/* TRAININGS_LIMIT_PER_PAGE */.jp, query[Filter/* FilterTypesInUrl.PAGE */.$R.PAGE] ? (Number(query[Filter/* FilterTypesInUrl.PAGE */.$R.PAGE]) - 1) * constants/* TRAININGS_LIMIT_PER_PAGE */.jp : 0);

          case 4:
            _yield$articleApi$lis = _context.sent;
            data = _yield$articleApi$lis.data;
            return _context.abrupt("return", {
              status: 200,
              articlesCount: data === null || data === void 0 ? void 0 : data.total_count,
              articles: data === null || data === void 0 ? void 0 : data.results
            });

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              status: 500,
              articlesCount: 0,
              articles: []
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var blog = (Blog);

/***/ }),

/***/ 93003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ articleApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var LIST = 'pv/article/list';
var DETAIL = 'pv/article/slug';
var articleApi = {
  list: function list(limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST, {
      limit: limit,
      offset: offset
    });
  },
  detail: function detail(slug) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug));
  }
};

/***/ }),

/***/ 23986:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(22579);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,a){ true?module.exports=a(__webpack_require__(67294)):0}(this,(e=>(()=>{var a={703:(e,a,t)=>{"use strict";var r=t(414);function n(){}function i(){}i.resetWarningCache=n,e.exports=function(){function e(e,a,t,n,i,s){if(s!==r){var o=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw o.name="Invariant Violation",o}}function a(){return e}e.isRequired=e;var t={array:e,bigint:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:a,element:e,elementType:e,instanceOf:a,node:e,objectOf:a,oneOf:a,oneOfType:a,shape:a,exact:a,checkPropTypes:i,resetWarningCache:n};return t.PropTypes=t,t}},697:(e,a,t)=>{e.exports=t(703)()},414:e=>{"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},98:a=>{"use strict";a.exports=e}},t={};function r(e){var n=t[e];if(void 0!==n)return n.exports;var i=t[e]={exports:{}};return a[e](i,i.exports,r),i.exports}r.n=e=>{var a=e&&e.__esModule?()=>e.default:()=>e;return r.d(a,{a}),a},r.d=(e,a)=>{for(var t in a)r.o(a,t)&&!r.o(e,t)&&Object.defineProperty(e,t,{enumerable:!0,get:a[t]})},r.o=(e,a)=>Object.prototype.hasOwnProperty.call(e,a),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n={};return(()=>{"use strict";r.r(n),r.d(n,{default:()=>k});var e=r(98),a=r.n(e),t=r(697),i=r.n(t);function s(){return s=Object.assign?Object.assign.bind():function(e){for(var a=1;a<arguments.length;a++){var t=arguments[a];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},s.apply(this,arguments)}var o=function(e){var t=e.pageClassName,r=e.pageLinkClassName,n=e.page,i=e.selected,o=e.activeClassName,l=e.activeLinkClassName,c=e.getEventListener,p=e.pageSelectedHandler,u=e.href,g=e.extraAriaContext,d=e.pageLabelBuilder,f=e.rel,b=e.ariaLabel||"Page "+n+(g?" "+g:""),v=null;return i&&(v="page",b=e.ariaLabel||"Page "+n+" is your current page",t=void 0!==t?t+" "+o:o,void 0!==r?void 0!==l&&(r=r+" "+l):r=l),a().createElement("li",{className:t},a().createElement("a",s({rel:f,role:u?void 0:"button",className:r,href:u,tabIndex:i?"-1":"0","aria-label":b,"aria-current":v,onKeyPress:p},c(p)),d(n)))};o.propTypes={pageSelectedHandler:i().func.isRequired,selected:i().bool.isRequired,pageClassName:i().string,pageLinkClassName:i().string,activeClassName:i().string,activeLinkClassName:i().string,extraAriaContext:i().string,href:i().string,ariaLabel:i().string,page:i().number.isRequired,getEventListener:i().func.isRequired,pageLabelBuilder:i().func.isRequired,rel:i().string};const l=o;function c(){return c=Object.assign?Object.assign.bind():function(e){for(var a=1;a<arguments.length;a++){var t=arguments[a];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},c.apply(this,arguments)}var p=function(e){var t=e.breakLabel,r=e.breakAriaLabel,n=e.breakClassName,i=e.breakLinkClassName,s=e.breakHandler,o=e.getEventListener,l=n||"break";return a().createElement("li",{className:l},a().createElement("a",c({className:i,role:"button",tabIndex:"0","aria-label":r,onKeyPress:s},o(s)),t))};p.propTypes={breakLabel:i().oneOfType([i().string,i().node]),breakAriaLabel:i().string,breakClassName:i().string,breakLinkClassName:i().string,breakHandler:i().func.isRequired,getEventListener:i().func.isRequired};const u=p;function g(e){var a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return null!=e?e:a}function d(e){return d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},d(e)}function f(){return f=Object.assign?Object.assign.bind():function(e){for(var a=1;a<arguments.length;a++){var t=arguments[a];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},f.apply(this,arguments)}function b(e,a){for(var t=0;t<a.length;t++){var r=a[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function v(e,a){return v=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,a){return e.__proto__=a,e},v(e,a)}function h(e,a){if(a&&("object"===d(a)||"function"==typeof a))return a;if(void 0!==a)throw new TypeError("Derived constructors may only return object or undefined");return m(e)}function m(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function y(e){return y=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},y(e)}function C(e,a,t){return a in e?Object.defineProperty(e,a,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[a]=t,e}var P=function(e){!function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),a&&v(e,a)}(o,e);var t,r,n,i,s=(n=o,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,a=y(n);if(i){var t=y(this).constructor;e=Reflect.construct(a,arguments,t)}else e=a.apply(this,arguments);return h(this,e)});function o(e){var t,r;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,o),C(m(t=s.call(this,e)),"handlePreviousPage",(function(e){var a=t.state.selected;t.handleClick(e,null,a>0?a-1:void 0,{isPrevious:!0})})),C(m(t),"handleNextPage",(function(e){var a=t.state.selected,r=t.props.pageCount;t.handleClick(e,null,a<r-1?a+1:void 0,{isNext:!0})})),C(m(t),"handlePageSelected",(function(e,a){if(t.state.selected===e)return t.callActiveCallback(e),void t.handleClick(a,null,void 0,{isActive:!0});t.handleClick(a,null,e)})),C(m(t),"handlePageChange",(function(e){t.state.selected!==e&&(t.setState({selected:e}),t.callCallback(e))})),C(m(t),"getEventListener",(function(e){return C({},t.props.eventListener,e)})),C(m(t),"handleClick",(function(e,a,r){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},i=n.isPrevious,s=void 0!==i&&i,o=n.isNext,l=void 0!==o&&o,c=n.isBreak,p=void 0!==c&&c,u=n.isActive,g=void 0!==u&&u;e.preventDefault?e.preventDefault():e.returnValue=!1;var d=t.state.selected,f=t.props.onClick,b=r;if(f){var v=f({index:a,selected:d,nextSelectedPage:r,event:e,isPrevious:s,isNext:l,isBreak:p,isActive:g});if(!1===v)return;Number.isInteger(v)&&(b=v)}void 0!==b&&t.handlePageChange(b)})),C(m(t),"handleBreakClick",(function(e,a){var r=t.state.selected;t.handleClick(a,e,r<e?t.getForwardJump():t.getBackwardJump(),{isBreak:!0})})),C(m(t),"callCallback",(function(e){void 0!==t.props.onPageChange&&"function"==typeof t.props.onPageChange&&t.props.onPageChange({selected:e})})),C(m(t),"callActiveCallback",(function(e){void 0!==t.props.onPageActive&&"function"==typeof t.props.onPageActive&&t.props.onPageActive({selected:e})})),C(m(t),"getElementPageRel",(function(e){var a=t.state.selected,r=t.props,n=r.nextPageRel,i=r.prevPageRel,s=r.selectedPageRel;return a-1===e?i:a===e?s:a+1===e?n:void 0})),C(m(t),"pagination",(function(){var e=[],r=t.props,n=r.pageRangeDisplayed,i=r.pageCount,s=r.marginPagesDisplayed,o=r.breakLabel,l=r.breakClassName,c=r.breakLinkClassName,p=r.breakAriaLabels,g=t.state.selected;if(i<=n)for(var d=0;d<i;d++)e.push(t.getPageElement(d));else{var f=n/2,b=n-f;g>i-n/2?f=n-(b=i-g):g<n/2&&(b=n-(f=g));var v,h,m=function(e){return t.getPageElement(e)},y=[];for(v=0;v<i;v++){var C=v+1;if(C<=s)y.push({type:"page",index:v,display:m(v)});else if(C>i-s)y.push({type:"page",index:v,display:m(v)});else if(v>=g-f&&v<=g+(0===g&&n>1?b-1:b))y.push({type:"page",index:v,display:m(v)});else if(o&&y.length>0&&y[y.length-1].display!==h&&(n>0||s>0)){var P=v<g?p.backward:p.forward;h=a().createElement(u,{key:v,breakAriaLabel:P,breakLabel:o,breakClassName:l,breakLinkClassName:c,breakHandler:t.handleBreakClick.bind(null,v),getEventListener:t.getEventListener}),y.push({type:"break",index:v,display:h})}}y.forEach((function(a,t){var r=a;"break"===a.type&&y[t-1]&&"page"===y[t-1].type&&y[t+1]&&"page"===y[t+1].type&&y[t+1].index-y[t-1].index<=2&&(r={type:"page",index:a.index,display:m(a.index)}),e.push(r.display)}))}return e})),void 0!==e.initialPage&&void 0!==e.forcePage&&console.warn("(react-paginate): Both initialPage (".concat(e.initialPage,") and forcePage (").concat(e.forcePage,") props are provided, which is discouraged.")+" Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"),r=e.initialPage?e.initialPage:e.forcePage?e.forcePage:0,t.state={selected:r},t}return t=o,(r=[{key:"componentDidMount",value:function(){var e=this.props,a=e.initialPage,t=e.disableInitialCallback,r=e.extraAriaContext,n=e.pageCount,i=e.forcePage;void 0===a||t||this.callCallback(a),r&&console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."),Number.isInteger(n)||console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(n,"). Did you forget a Math.ceil()?")),void 0!==a&&a>n-1&&console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(a," > ").concat(n-1,").")),void 0!==i&&i>n-1&&console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(i," > ").concat(n-1,")."))}},{key:"componentDidUpdate",value:function(e){void 0!==this.props.forcePage&&this.props.forcePage!==e.forcePage&&(this.props.forcePage>this.props.pageCount-1&&console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage," > ").concat(this.props.pageCount-1,").")),this.setState({selected:this.props.forcePage})),Number.isInteger(e.pageCount)&&!Number.isInteger(this.props.pageCount)&&console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount,"). Did you forget a Math.ceil()?"))}},{key:"getForwardJump",value:function(){var e=this.state.selected,a=this.props,t=a.pageCount,r=e+a.pageRangeDisplayed;return r>=t?t-1:r}},{key:"getBackwardJump",value:function(){var e=this.state.selected-this.props.pageRangeDisplayed;return e<0?0:e}},{key:"getElementHref",value:function(e){var a=this.props,t=a.hrefBuilder,r=a.pageCount,n=a.hrefAllControls;if(t)return n||e>=0&&e<r?t(e+1,r,this.state.selected):void 0}},{key:"ariaLabelBuilder",value:function(e){var a=e===this.state.selected;if(this.props.ariaLabelBuilder&&e>=0&&e<this.props.pageCount){var t=this.props.ariaLabelBuilder(e+1,a);return this.props.extraAriaContext&&!a&&(t=t+" "+this.props.extraAriaContext),t}}},{key:"getPageElement",value:function(e){var t=this.state.selected,r=this.props,n=r.pageClassName,i=r.pageLinkClassName,s=r.activeClassName,o=r.activeLinkClassName,c=r.extraAriaContext,p=r.pageLabelBuilder;return a().createElement(l,{key:e,pageSelectedHandler:this.handlePageSelected.bind(null,e),selected:t===e,rel:this.getElementPageRel(e),pageClassName:n,pageLinkClassName:i,activeClassName:s,activeLinkClassName:o,extraAriaContext:c,href:this.getElementHref(e),ariaLabel:this.ariaLabelBuilder(e),page:e+1,pageLabelBuilder:p,getEventListener:this.getEventListener})}},{key:"render",value:function(){var e=this.props.renderOnZeroPageCount;if(0===this.props.pageCount&&void 0!==e)return e?e(this.props):e;var t=this.props,r=t.disabledClassName,n=t.disabledLinkClassName,i=t.pageCount,s=t.className,o=t.containerClassName,l=t.previousLabel,c=t.previousClassName,p=t.previousLinkClassName,u=t.previousAriaLabel,d=t.prevRel,b=t.nextLabel,v=t.nextClassName,h=t.nextLinkClassName,m=t.nextAriaLabel,y=t.nextRel,C=this.state.selected,P=0===C,k=C===i-1,x="".concat(g(c)).concat(P?" ".concat(g(r)):""),L="".concat(g(v)).concat(k?" ".concat(g(r)):""),N="".concat(g(p)).concat(P?" ".concat(g(n)):""),O="".concat(g(h)).concat(k?" ".concat(g(n)):""),R=P?"true":"false",E=k?"true":"false";return a().createElement("ul",{className:s||o,role:"navigation","aria-label":"Pagination"},a().createElement("li",{className:x},a().createElement("a",f({className:N,href:this.getElementHref(C-1),tabIndex:P?"-1":"0",role:"button",onKeyPress:this.handlePreviousPage,"aria-disabled":R,"aria-label":u,rel:d},this.getEventListener(this.handlePreviousPage)),l)),this.pagination(),a().createElement("li",{className:L},a().createElement("a",f({className:O,href:this.getElementHref(C+1),tabIndex:k?"-1":"0",role:"button",onKeyPress:this.handleNextPage,"aria-disabled":E,"aria-label":m,rel:y},this.getEventListener(this.handleNextPage)),b)))}}])&&b(t.prototype,r),Object.defineProperty(t,"prototype",{writable:!1}),o}(e.Component);C(P,"propTypes",{pageCount:i().number.isRequired,pageRangeDisplayed:i().number,marginPagesDisplayed:i().number,previousLabel:i().node,previousAriaLabel:i().string,prevPageRel:i().string,prevRel:i().string,nextLabel:i().node,nextAriaLabel:i().string,nextPageRel:i().string,nextRel:i().string,breakLabel:i().oneOfType([i().string,i().node]),breakAriaLabels:i().shape({forward:i().string,backward:i().string}),hrefBuilder:i().func,hrefAllControls:i().bool,onPageChange:i().func,onPageActive:i().func,onClick:i().func,initialPage:i().number,forcePage:i().number,disableInitialCallback:i().bool,containerClassName:i().string,className:i().string,pageClassName:i().string,pageLinkClassName:i().string,pageLabelBuilder:i().func,activeClassName:i().string,activeLinkClassName:i().string,previousClassName:i().string,nextClassName:i().string,previousLinkClassName:i().string,nextLinkClassName:i().string,disabledClassName:i().string,disabledLinkClassName:i().string,breakClassName:i().string,breakLinkClassName:i().string,extraAriaContext:i().string,ariaLabelBuilder:i().func,eventListener:i().string,renderOnZeroPageCount:i().func,selectedPageRel:i().string}),C(P,"defaultProps",{pageRangeDisplayed:2,marginPagesDisplayed:3,activeClassName:"selected",previousLabel:"Previous",previousClassName:"previous",previousAriaLabel:"Previous page",prevPageRel:"prev",prevRel:"prev",nextLabel:"Next",nextClassName:"next",nextAriaLabel:"Next page",nextPageRel:"next",nextRel:"next",breakLabel:"...",breakAriaLabels:{forward:"Jump forward",backward:"Jump backward"},disabledClassName:"disabled",disableInitialCallback:!1,pageLabelBuilder:function(e){return e},eventListener:"onClick",renderOnZeroPageCount:void 0,selectedPageRel:"canonical",hrefAllControls:!1});const k=P})(),n})()));
//# sourceMappingURL=react-paginate.js.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,6506,9774,2888,179], function() { return __webpack_exec__(23986); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);